import type { SVGProps } from 'react';

import { cn } from '../../utils/cn';

const Discord = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 126.64 96"
    {...props}
    className={cn('text-[#5865f2] transition-colors duration-150', className)}
  >
    <title>Discord Logo</title>
    <path
      fill="currentColor"
      d="M81.15 0a73.81 73.81 0 0 0-3.36 6.79 97.81 97.81 0 0 0-28.99 0A67.96 67.96 0 0 0 45.44 0C36.42 1.54 27.63 4.24 19.3 8.06 2.78 32.53-1.69 56.37.53 79.89c9.67 7.15 20.51 12.6 32.05 16.09 2.6-3.49 4.9-7.2 6.87-11.06-3.74-1.39-7.35-3.13-10.81-5.15.91-.66 1.79-1.34 2.65-2a75.243 75.243 0 0 0 64.08 0c.86.71 1.74 1.39 2.65 2a68.978 68.978 0 0 1-10.83 5.18c1.97 3.86 4.27 7.58 6.87 11.06 11.54-3.49 22.38-8.92 32.05-16.06 2.63-27.28-4.5-50.92-18.82-71.85A103.55 103.55 0 0 0 81.18.05L81.15 0ZM42.28 65.41c-6.24 0-11.42-5.66-11.42-12.65s4.98-12.68 11.39-12.68 11.52 5.71 11.42 12.68c-.1 6.97-5.03 12.65-11.39 12.65Zm42.08 0c-6.26 0-11.39-5.66-11.39-12.65s4.98-12.68 11.39-12.68 11.49 5.71 11.39 12.68c-.1 6.97-5.03 12.65-11.39 12.65Z"
    />
  </svg>
);

export default Discord;
